import React from "react";

const AgentsIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
  >
    <path
      fill="#4A4A4A"
      d="M17.1 14.475a2.27 2.27 0 0 1-1.669-.681 2.27 2.27 0 0 1-.681-1.669q0-.987.681-1.668a2.27 2.27 0 0 1 1.669-.682 2.27 2.27 0 0 1 1.668.682 2.27 2.27 0 0 1 .682 1.668 2.27 2.27 0 0 1-.681 1.669 2.27 2.27 0 0 1-1.669.681m-4.9 4.775v-.525q0-.572.275-1.061.275-.488.775-.764a8.3 8.3 0 0 1 3.85-.925q1.025 0 2 .225t1.85.7q.525.25.788.747.262.496.262 1.078v.525q0 .319-.215.534a.73.73 0 0 1-.535.216h-8.3a.73.73 0 0 1-.534-.216.73.73 0 0 1-.216-.534M10 11.975q-1.65 0-2.7-1.05t-1.05-2.7 1.05-2.7 2.7-1.05 2.7 1.05 1.05 2.7-1.05 2.7-2.7 1.05M2 17.65q0-.85.425-1.562T3.692 15a19 19 0 0 1 3.22-1.125 13 13 0 0 1 3.082-.375q.806 0 1.431.075.626.075 1.35.225l-.638.638-.637.637a6 6 0 0 0-.7-.062Q10.425 15 10 15q-1.416 0-2.77.288-1.355.287-2.93 1.062-.35.175-.575.55t-.225.75v.85h7.2v.694q0 .231.1.444.1.212.25.362H3.5q-.62 0-1.06-.44A1.44 1.44 0 0 1 2 18.5zm8-7.175q.975 0 1.613-.637.637-.638.637-1.613t-.637-1.612T10 5.975t-1.613.638-.637 1.612.637 1.613 1.613.637"
    ></path>
  </svg>
);

export default AgentsIcon;
